import * as React from "react"
import { useLocalization } from "../hooks/use-localization"

const Seo = ({ pageContext }) => {
  const { config } = useLocalization()

  const translations = pageContext.translations.map(translation => {
    translation.hrefLang = config.find(
      c => c.code === translation.locale
    )?.hrefLang
    return translation
  })

  const pageHrefLang = config.find(c => c.code === pageContext.locale)?.hrefLang

  return (
    <>
      <meta property="og:locale" content={pageHrefLang.replace(`-`, `_`)} />
      {translations.length > 1 &&
        translations.map(l => {
          const pageHrefLang = config.find(
            c => c.code === pageContext.locale
          )?.hrefLang

          if (!pageHrefLang) return null

          return (
            <>
              <link
                key={l.locale}
                rel="alternate"
                hrefLang={l.hrefLang}
                href={l.slug}
              />
              <meta
                key={l.locale}
                property="og:locale:alternate"
                content={pageHrefLang.replace(`-`, `_`)}
              />
            </>
          )
        })}
    </>
  )
}

export { Seo }
